<div class="row p-5">
  <div class="col-12 d-flex justify-content-center">
    <div class="not-found-img" [ngClass]="code == 'server-error' ? 'error-img' : 'not-found-img'"></div>
  </div>
  <div class="pt-2 col-12 d-flex justify-content-center">
    <div class="error-description">
      {{ title }}
    </div>
  </div>
  <div class="col-12 d-flex justify-content-center text-center">
    <div class="error-instructions" [innerHTML]="subtitle">
    </div>
  </div>
</div>
